import { compareAsc, compareDesc, parse } from "date-fns";

export const filtrarEventos = (actasFilter, filtersFields, order, orderField) => {
  // console.log(filtersFields);
  const filteredData = actasFilter.filter((item) => {
    // console.log(item);
    return Object.entries(filtersFields).every(([key, value]) => {
      value = value.toLowerCase();
      if (key == "created_at") {
        if (actasFilter?.created_at?.includes(value) || value == null || value == "") {
          return item;
        }
      }

      if (key == "description") {
        if (actasFilter?.created_at?.includes(value) || value == null || value == "") {
          return item;
        }
      }

      if (key == "numero_acta") {
        if (actasFilter?.created_at?.includes(value) || value == null || value == "") {
          return item;
        }
      }

      const resp =
        String(item.causer?.correoElectronico)?.toString().toLowerCase().includes(value) ||
        String(item.subject?.numero_acta)?.toString().toLowerCase().includes(value) ||
        String(item.acta?.numero_infraccion)?.toString().toLowerCase().includes(value) ||
        String(item?.description)?.toString().toLowerCase().includes(value) ||
        String(item.causer?.correoElectronico)?.toString().toLowerCase().includes(value);
      if (resp) {
        return item;
      }
      return item[key] && item[key].toString().toLowerCase().includes(value.toLowerCase());
    });
  });

  // Ordenar los datos
  // console.log(orderField);
  const sortedData = filteredData.sort((a, b) => {
    if (orderField == "created_at") {
      // console.log("entre");
      // console.log(a);
      // console.log(b);
      const aFecha = parse(a.created_at, "dd/MM/yyyy HH:mm:ss", new Date());
      const bFecha = parse(b.created_at, "dd/MM/yyyy HH:mm:ss", new Date());
      if (order === "des") {
        return compareDesc(aFecha, bFecha);
      } else {
        return compareAsc(aFecha, bFecha);
      }
    } else {
      if (order === "asc") {
        return a[orderField] > b[orderField] ? 1 : -1;
      } else if (order === "des") {
        return a[orderField] < b[orderField] ? 1 : -1;
      }
      return 0;
    }
    // Si order no es 'asc' ni 'des', no hacer nada
  });

  return sortedData;
};
